// components
import { GridRow } from '@mui/x-data-grid-pro';
import Tooltip from 'components/shared/Tooltip';
import { SummaryCard } from 'components/mrp/components/SummaryCard';

// libs
import { FC } from 'react';

// types
import { AppointmentSummaryProps } from './AppointmentSummary.types';

// utils
import { convertSummaryToAppointmentEvent } from './AppointmentSummary.utils';

export const AppointmentSummary: FC<AppointmentSummaryProps> = ({
  appointmentSummary,
  gridRow
}: AppointmentSummaryProps) => {
  if (!appointmentSummary) return <GridRow {...gridRow} />;

  const event = convertSummaryToAppointmentEvent(appointmentSummary);

  if (!event || !gridRow) return <></>;

  return (
    <Tooltip
      arrow
      enterDelay={100}
      enterNextDelay={100}
      title={<SummaryCard event={event} interactable={false} />}
    >
      <GridRow {...gridRow} />
    </Tooltip>
  );
};

export default AppointmentSummary;
